// extracted by extract-css-chunks-webpack-plugin
module.exports = {"display-none":"display-none_i4fPL","shortDesc":"shortDesc_TNJIb","shortDescExpanded":"shortDescExpanded_G3-oD"};